import cleanObject from "../../../utils/clean-objects";
import BaseTrackingService from "../BaseTrackingService";
import { handleAxiosErrorMessage } from "../customErrors/apiErrors";
import { EVENTS } from "./trackEvents";

class CancelPlanTrackingService extends BaseTrackingService {
  static EVENT_PLATFORM_PLAN_CANCEL = EVENTS.PLATFORM_PLAN_CANCEL;
  static EVENT_PLAN_CANCEL_CONFIRM = EVENTS.PLATFORM_PLAN_CANCEL_CONFIRMED;
  static EVENT_PLATFORM_PLAN_CANCEL_SUCCESS =
    EVENTS.PLATFORM_PLAN_CANCEL_SUCCESS;
  static EVENT_PLATFORM_PLAN_CANCEL_ERROR = EVENTS.PLATFORM_PLAN_CANCEL_ERROR;

  constructor() {
    super("CancelPlanTrackingService");
  }

  _buildBasicData(userData, currentPlan) {
    return {
      ...this._buildSegmentUserEventProperties(userData),

      current_plan_id: currentPlan?.plan_details?.id,
      current_plan_name: currentPlan?.plan_details?.name,
      current_plan_amount: currentPlan?.plan_details?.amount,
      current_plan_type: currentPlan?.plan_details?.plan_type,
    };
  }

  /**
   * Monta propriedades para `trackPlatformPlanCancel` em trackEvents.ts.
   */
  preparePlatformPlanCancelForAnalytics(userData, currentPlan, step) {
    return {
      ...this._buildBasicData(userData, currentPlan),
      provider: currentPlan?.info?.provider || "unknown",
      context: "cancel",
      timestamp: new Date().toISOString(),
      event_type: this.constructor.EVENT_PLATFORM_PLAN_CANCEL,
      conversion_value: 0,
      cancel_step: step || "initiated",
    };
  }

  /**
   * Monta propriedades para `trackPlatformPlanCancelConfirmed` em trackEvents.ts.
   */
  preparePlatformPlanCancelConfirmForAnalytics(
    userData,
    currentPlan,
    step,
    values = {}
  ) {
    return {
      ...this._buildBasicData(userData, currentPlan),
      provider: currentPlan?.info?.provider || "unknown",
      context: "cancel",
      timestamp: new Date().toISOString(),
      event_type: this.constructor.EVENT_PLAN_CANCEL_CONFIRM,
      conversion_value: 0,
      cancel_step: step || "initiated",
      ...values,
    };
  }

  /**
   * Monta propriedades para `trackPlatformPlanCancelSuccess` em trackEvents.ts.
   */
  preparePlatformPlanCancelSuccessForAnalytics(userData, currentPlan, reasons) {
    const reasonCleanData = cleanObject(reasons) || {};
    return {
      ...this._buildBasicData(userData, currentPlan),
      ...reasonCleanData,
      provider: currentPlan?.info?.provider || "unknown",
      context: "cancel",
      timestamp: new Date().toISOString(),
      event_type: this.constructor.EVENT_PLATFORM_PLAN_CANCEL_SUCCESS,
      conversion_value: 0,
      cancel_step: "success",
    };
  }

  /**
   * Monta propriedades para `trackPlatformPlanCancelError` em trackEvents.ts.
   */
  preparePlatformPlanCancelErrorForAnalytics(userData, currentPlan, error, reasons) {
    const reasonCleanData = cleanObject(reasons) || {};
    const {
      message = null,
      status = null,
      data = null,
    } = handleAxiosErrorMessage(error) || {};
    return {
      ...this._buildBasicData(userData, currentPlan),
      ...reasonCleanData,
      provider: currentPlan?.info?.provider || "unknown",
      context: "cancel",
      timestamp: new Date().toISOString(),
      event_type: this.constructor.EVENT_PLATFORM_PLAN_CANCEL_ERROR,
      conversion_value: 0,
      cancel_step: "error",
      error_message: message,
      error_data: data,
      error_status: status
    };
  }
}

export default new CancelPlanTrackingService();
